import React from 'react';

export const RESILIENCE_FIELDS = {
        pipelineName: {
            id: "pipelineName",
            value: "",
            name: "Pipeline Name",
            mandatory: true,
            description: "The name of the pipeline",
            type: "text"
        },
        sourceAwsAccountName: {
            id: "sourceAwsAccountName",
            value: "",
            name: "Source AWS Account Name",
            mandatory: false,
            description: "The AWS resources will be copied from this account.",
            type: "text"
        },
        sourceAwsAccountId: {
            id: "sourceAwsAccountId",
            value: "",
            name: "Source AWS Account Id",
            mandatory: false,
            description: "The AWS Account Id for the above mentioned AWS account.",
            type: "text",
        },
        anvilId: {
            id: "anvilId",
            value: "",
            name: "Anvil Id",
            mandatory: true,
            description: "Anvil application Id for pipeline",
            type: "select",
        },
        anvilIds: {
            id: "anvilIds",
            value: "",
            mandatory: false
        },
        additionalInfo: {
            id: "additionalInfo",
            value: "",
            name: "Additional information",
            description: "Any additional information regarding your setup ",
            type: "textarea",
            hintText: "Specify all details which you want ROSLIN team to review",
            placeholder: "CDK with ECS Fargate created using BONES CLI"
        },
        stackCreationMechanism: {
            id: "stackCreationMechanism",
            value: "",
            name: "Stack creation mechansism",
            mandatory: false,
            type: "radio",
        },
        infrastructureSetup: {
            id: "infrastructureSetup",
            value: "",
            name: "Infrastructure management setup",
            mandatory: false,
            type: "radio",
        },

        //TEAM Details
        teamAlias: {
            id: "teamAlias",
            value: "",
            name: "Team Alias",
            mandatory: true,
            description: "Team email list for resource creations",
            type: "text",
            placeholder: "team@amazon.com"
        },
        bindleOwner: {
            id: "bindleOwner",
            value: "",
            name: "Application Owner",
            mandatory: true,
            description: "The owner of the application. Expecting SDMs alias. This owner field will be used for creating host classes.",
            type: "text",
            hintText: "SDM's alias without @amazon.com",
            regEx: /^((?!@).)*$/
        },
        teamCategory: {
            id: "teamCategory",
            value: "",
            name: "Category",
            mandatory: true,
            description: "Category of the Team",
            type: "text"
        },
        teamType: {
            id: "teamType",
            value: "",
            name: "Type",
            mandatory: true,
            description: "Type of of the Team",
            type: "text"
        },
        teamItem: {
            id: "teamItem",
            value: "",
            name: "Item",
            mandatory: true,
            description: "Item of of the Team",
            type: "text"
        },
        teamResolverGroup: {
            id: "teamResolverGroup",
            value: "",
            name: "Resolver Group",
            mandatory: true,
            description: "Resolver group of of the Team",
            type: "text"
        },
        folderId: {
            id: "folderId",
            value: "",
            name: "Folder Id",
            mandatory: false,
            description: "Folder ID of the Team",
            type: "text"
        },

        //Pod Details
        parentEnvironmentName: {
            id: "parentEnvironmentName",
            value: "",
            name: "Parent Environment Name",
            mandatory: true,
            description: "This will be parent for all environments in the region. Each cell will be created as a child of this.",
            type: "text",
            hintText: "Eg : FCTravelTimeService/NA"
        },
        createParentEnvironment: {
            id: "createParentEnvironment",
            value: "",
            name: "Should Parent Environment be created as well?",
            mandatory: false,
            description: "If selected yes, the above mentioned environment is created.",
            type: "radio",
        },
        bindleGuid: {
            id: "bindleGuid",
            value: "",
            name: "Bindle GUID",
            mandatory: true,
            description: "The Bindle GUID for the pipeline",
            type: "text",
            hintText: "Eg : amzn1.bindle.resource.35vyrwf7v2srhp6vrhb3tae4a"
        },
        appBindleId: {
            id: "appBindleId",
            value: "",
            name: "Application bindle ID",
            mandatory: true,
            description: "The bindle Id for the Software application",
            type: "text",
        },
        bindleName: {
            id: "bindleName",
            value: "",
            name: "Application Bindle Name",
            mandatory: true,
            description: "The bindle name for the Software application",
            type: "text",
        },
        region: {
            id: "region",
            value: "",
            name: "Region",
            mandatory: true,
            description: "The region to which Environment belongs to.",
            type: "select",
        },
        dps: {
            id: "dps",
            value: "",
            name: "Deployment Preference Set List",
            mandatory: false,
            description: "The List of Deployment Preference Sets for the pipeline",
            type: "text",
            hintText: "This is a comma seperated list. Eg. dps1,dps2"
        },
        alias: {
            id: "alias",
            value: "",
            name: "Apollo Environment Name",
            mandatory: true,
            description: "The alias name for the environment",
            type: "text",
            hintText: "Eg : FCTravelTimeService",
            regEx: /^[ A-Za-z0-9_-]*$/
        },

        //Fleet details
        fleetName: {
            id: "fleetName",
            value: "",
            name: "Fleet Name",
            mandatory: true,
            description: "The Fleet Name which has to be mapped with the AWS account",
            type: "text",
        },
        fleetId: {
            id: "fleetId",
            value: "",
            name: "Fleet Id",
            mandatory: true,
            description: "The fleet Id of the above mentioned fleet name",
            type: "text",
        },
        fleetOwner: {
            id: "fleetOwner",
            value: "",
            name: "Fleet Owner",
            mandatory: true,
            description: "The fleet owner of the above fleet.",
            type: "text",
            hintText: "Provide a valid Amazon alias. It shold be a sigle login Id, should not contain special characters",
            regEx: /^[0-9a-zA-Z|\\-]{1,32}$/
        },
        cdkPackageName: {
            id: "cdkPackageName",
            value: "",
            name: "CDK Package name",
            description: "This package name will be used to create a infrastructure package to deploy the AWS resources in new cell level AWS accounts.",
            hintText: "Eg: SNOWPlatformServiceCDK",
            mandatory: true,
            type: "text"
        },
        cdkVersionSetName: {
            id: "cdkVersionSetName",
            value: "",
            name: "CDK pipeline Version set name",
            description: "This version set will be created and deployed in CDK pipeline.",
            hintText: "Eg: SNOWPlatform/development",
            type: "text",
            mandatory: true,
        },
        cdkPipelineName: {
            id: "cdkPipelineName",
            value: "",
            name: "CDK Pipeline name",
            description: "This is Infrastructure pipeline which will be created and userd for deploying AWS resources in new cell level AWS accounts.",
            hintText: "Eg: SNOWPlatformServiceInfra",
            type: "text",
            mandatory: true,
        },
        posixGroup: {
            id: "posixGroup",
            value: "",
            name: "Posix group",
            description: "This posix group will be associated to the CDK Pipeline.",
            type: "text",
            mandatory: true,
        },
}

export const CELL_FIELDS = {

        // Host Class Information
        parentHostClass: {
            id: "parentHostClass",
            value: "",
            name: "Parent Host Class",
            mandatory: true,
            description: "The existing Parent HostClass for the ASGs",
            type: "select",
            hintText: "Eg : FC-COPS-INTEG"
        },
        parentHostClasses: {
            id: "parentHostClasses",
            value: "",
            mandatory: false
        },
        asgHostPrefix: {
            id: "asgHostPrefix",
            value: "",
            name: "ASG Host Prefix",
            mandatory: true,
            description: "The ASG Host Prefix for the Hosts",
            type: "text",
            regEx: /^[A-Z-0-9]{1,29}$/,
            hintText: "The length of ASG Host Prefix should be less than 29 characters. Eg : FC-COPS-INTEG."
        },
        hostClass: {
            id: "hostClass",
            value: "",
            name: "Host Class",
            mandatory: true,
            description: "The Host class for the environment",
            type: "text",
            regEx: /^[A-Z-0-9]{1,29}$/,
            hintText: "The length of Host class should be less than 29 characters.Eg : FC-COPS-INTEG-IADCELL1"
        },
        availabiltyZones: {
            id: "availabiltyZones",
            value: "",
            name: "Select the ASGs to be created",
            mandatory: true,
            type: "multiselect",
        },
        numberOfHosts: {
            id: "numberOfHosts",
            value: "",
            name: "Number of Hosts in each availability zone",
            mandatory: true,
            description: "Number of hosts needed for each availability zone. These hosts will be ordered into the ASG",
            type: "text",
        },
        hostFabric: {
            id: "hostFabric",
            value: "",
            name: "Fabric",
            mandatory: true,
            description: "The Fabric of the Host",
            type: "select",
        },
        hostOs: {
            id: "hostOs",
            value: "",
            name: "Host OS",
            mandatory: true,
            description: "The Operating System for the hosts",
            type: "select",
            hintText: "Eg : Amazon Linux 2 5.4 Kernel x86_64"
        },
        instanceType: {
            id: "instanceType",
            value: "",
            name: "Instance Type",
            mandatory: true,
            description: "The Instance Type to be created",
            type: "select",
            hintText: "Eg : m5.large"
        },

        // POD INFORMATION
        environmentName: {
            id: "environmentName",
            value: "",
            name: "Pod Environment Name",
            mandatory: true,
            description: "The Environment Name for the selected cell.",
            type: "text",
            hintText: "Eg : FCTravelTimeService/IADCell1"
        }, 
        opconfigDetails: {
            id: "opconfigDetails",
            value: "",
            name: "Opconfig Details",
            description: "The opconfig details to be created for the environment",
            type: "code",
        },
        addServiceableWarehouseIds: {
            id: "addServiceableWarehouseIds",
            value: "",
            name: "Add serviceableWarehouseIds opconfig?",
            mandatory: false,
            description: "If Yes, it will be auto populated in the opconfig",
            type: "radio",
        },
        deploymentPreferenceSet: {
            id: "deploymentPreferenceSet",
            value: "",
            name: "Deployment Preference Set",
            mandatory: true,
            description: "Select the Deployment Preference Set for the selected cell",
            hintText: "If the required dps is not present in dropdown, select 'Other' and manually enter your Deployment Preference Set below.",
            type: "select",
        },
        // VIP Details
        httpPort: {
          id: "httpPort",
          value: "",
          name: "HTTP Port",
          mandatory: false,
          description: "HTTP port for tardigrade VIP",
          type: "text",
          placeholder: "8000"
        },
        httpsPort: {
          id: "httpsPort",
          value: "",
          name: "HTTPS Port",
          mandatory: false,
          description: "HTTPS port for tardigrade VIP",
          type: "text",
          placeholder: "8001"
        },
        dnsName: {
          id: "dnsName",
          value: "",
          name: "CNAME Name",
          description: "This will be used to create FC Specific DNS endpoint",
          type: "text",
          hintText: "dockmaster-<fc>.aka.amazon.com"
        },
        vipType: {
            id: "vipType",
            value: "",
            name: "VIP Type",
            description: "It is a readonly select field which was autopopulated based on the logic that pipeline has CDORelayConsumable environment as one of its consumable or not.",
            type: "select",
            mandatory: true
        },
        vipName: {
          id: "vipName",
          value: "",
          name: "VIP Name",
          description: "Enter the VIP Details",
          type: "text",
          mandatory: true
        },
        vipSchema: {
          id: "vipSchema",
          value: "",
          name: "VIP Schema",
          description: "Select if the VIP to be created should be internal or external",
          type: "radio",
        },
        existingVipName:  {
            id: "existingVipName",
            value: "",
            name: "Existing VIP Name",
            description: "This VIP name is used to get the existing Redfort certificate Material set and clone permissions to newly created odin through redfort.",
            type: "text",
            mandatory: true
        },
        tardigradePort: {
            id: "tardigradePort",
            value: "",
            name: "Port Number",
            mandatory: false,
            description: "HTTPS port that Tardigrade load balancer listens to.",
            hintText: "Eg: 80 or 443",
            regEx: /^[0-9]{2,3}$/,
            type: "text",
        },
        tardigradeCdoRelay: {
            id: "tardigradeCdoRelay",
            value: "",
            name: "CDO Relay Port Number",
            mandatory: false,
            description: "The HTTPS port CDORelay listens to and Tardigrades forwards HTTPS requests to.",
            regEx: /^[0-9]+$/,
            type: "text",
        },
        vipShortName: {
            id: "vipShortName",
            value: "",
            name: "Load Balancer Short Name",
            mandatory: false,
            description: "Load Balancer Short Name",
            type: "text",
        },
        netscalerProtocol: {
            id: "netscalerProtocol",
            value: "",
            name: "Protocol",
            mandatory: false,
            description: "(HTTP, TCP or SSL)",
            type: "select",
        },
        netscalerPort: {
            id: "netscalerPort",
            value: "",
            name: "VIP Port Number",
            mandatory: false,
            description: "TCP/UDP port number",
            type: "text",
            hintText: "Eg: 80 or 443",
            regEx: /^[0-9]{2,3}$/
        },
        servicePortNumber: {
            id: "servicePortNumber",
            value: "",
            name: "Service Port number",
            mandatory: false,
            type: "text",
            regEx: /^[0-9]+$/
        },
        netscalerCluster: {
            id: "netscalerCluster",
            value: "",
            name: "Cluster - Region",
            mandatory: false,
            description: "(e.g. DUB, FRA, IAD)",
            type: "text",
        },
        netscalerInstanceDNS: {
            id: 'netscalerInstanceDNS',
            value: "",
            name: "DNS",
            mandatory: false,
            description: "DNS name",
            type: "text",
        },
        netscalerInstancePort:  {
            id: 'netscalerInstancePort',
            value: "",
            name: "Port",
            mandatory: false,
            description: "Port Number",
            type: "text",
        }
}

export const AWS_SOURCE_DATA = {
    awsDataMap: {
        id: "sourceAwsAccountNames",
        value: "",
        name: "Source AWS Account Name(s)",
        mandatory: false,
        description: "The AWS resources will be copied from this account. Number of accounts selected here will be replicated in each cell.",
        type: "multiselect"
    }
}

export const REGION_TO_CLUSTER_MAP = {
    NA: "IAD",
    EU: "DUB",
    JP: "NRT"
}

export const AWS_FIELDS = {
        awsDataMap: {
            id: "sourceAwsAccountNames",
            value: "",
            name: "Source AWS Account Name(s)",
            mandatory: false,
            description: "The AWS resources will be copied from this account. Number of accounts selected here will be replicated in each cell.",
            type: "multiselect"
        },
        sourceAwsAccountId: {
            id: "sourceAwsAccountId",
            value: "",
            name: "Source AWS Account Id",
            mandatory: false,
            description: "The AWS Account Id for the above mentioned AWS account.",
            type: "text",
        },
        destinationAccountName: {
            id: "destinationAccountName",
            value: "",
            name: "Destination Account Name",
            mandatory: false,
            description: "The Account Name for the AWS account corresponding to the given cell",
            type: "text",
            hintText: "Eg : PipelineName-IadCell1, the name of destination AWS account. Please make sure it is unique does not already exist"
        },
        destinationAwsAccountId: {
            id: "destinationAwsAccountId",
            value: "",
            name: "AWS Account Id",
            mandatory: false,
            description: "The AWS Account Id for the above mentioned AWS account.",
            type: "text",
            hintText: "The Account Id of the above AWS account. This is destination AWS account",
        },
        awsAccountForNLB: {
            id: "awsAccountForNLB",
            value: "",
            name: "Source AWS Account for NLB",
            mandatory: true,
            description: "The AWS account which will be used to create Network load balancer. Above chosen source AWS account correspondant destination AWS account will be used for creating it.",
            type: "text",
            hintText: "Please choose one of the above source AWS accounts."
        },
        odinDetails: {
            id: "odinDetails",
            value: "",
            name: "ODIN Material Set Names",
            mandatory: false,
            description: "Odin Material Set names to which new host classes will be added to.",
            type: "textarea",
            hintText: "Note: These Odins need to exist already and the newly created cell level host classes will be added to these host classes."
        },
        odinDetailsToBeCreated: {
            id: "odinDetailsToBeCreated",
            value: "",
            name: "ODIN Material Sets Names To Be Created",
            mandatory: false,
            description: "Odin Material Set names which would need to be created.",
            type: "textarea",
        },
        copyAwsResourcesFromSource: {
            id: "copyAwsResourcesFromSource",
            value: "",
            name: "Should the AWS resources get copied from source account",
            description: "",
            type: "text"
        },
        comments: {
            id: "comments",
            value: "",
            name: "Feedback or comments",
            description: "Please add any feedbacks or comments specific to your service that you wanted to share with Resilience Team",
            type: "textarea",
            hintText: "",
            placeholder: "Feedbacks / Comments"
        },

}

export const INFRASTRUCTURE_SETUP = [
    {
        "label": "MAWS Apollo setup",
        "value": "maws",
        "description": "We currently support only automating MAWS Apollo environment setup creation." 
    },
    {
        "label": "Infrastructure as code through CDK or CFNBuild LPT pipelines",
        "value": "cdk",
        "description": "This is not supported currently. We are collecting more information on any possible automated solutions we can provide. Please reach out to reselience team with the data.",
        "disabled":true
    },
    {
        "label": "Others",
        "value": "others",
        "description": "Please explain in usecase details"
    }
]

export const BINDLE_PERMISSIONS_DESCRIPTION = <span>These permissions are required for the SNOW Workflow to create resources under your software App Bindle programatically. Make sure that the permissions are granted via the 1-click Bindles approval below.</span>;
export const HOSTCLASS_PERMISSIONS_DESCRIPTION = <span>These permissions are required for the SNOW Workflow to create host classes programatically. Make sure to follow below process to grant access.</span>;
export const TEAMS_PERMISSION_DESCRIPTION = <span>These permissions are required for the SNOW Workflow to create Redfort certificate programatically.  Make sure to follow below process to grant access.</span>;
export const BINDLE_HOST_CLASS_URL = "https://bindles.amazon.com/hc/register";
export const PERMISSIONS_URL = "https://permissions.amazon.com/hostclass.mhtml"
export const PERMISSIONS_TEAM_URL = "https://permissions.amazon.com/a/team";

export const REGIONS = [
    {
        "label": "NA",
        "id": "NA"
    },
    {
        "label": "IN",
        "id": "IN",
        "disabled" : true
    },
    {
        "label": "EU",
        "id": "EU", 
        "disabled" : true
    },
    {
        "label": "JP",
        "id": "JP",
        "disabled" : true
    }
]
 
export const NETSCALER_PROTOCOL_OPTIONS = [
    {
        "label": "HTTP",
        "id": "HTTP"
    },
    {
        "label": "TCP",
        "id": "TCP"
    },
    {
        "label": "SSL",
        "id": "SSL"
    }
]
 
export const VIP_TYPES = (vipType) => {

    const isDisabled = vipType && vipType === 'Tardigrade' ? false : true

    return [
        {
            "label": "Tardigrade",
            "id": "Tardigrade",
            "disabled": vipType ? isDisabled : false
        },
        {
            "label": "Netscaler",
            "id": "Netscaler",
            "disabled": vipType ? !isDisabled : false
        },
    ]
}

export const STACK_CREATION = [
    {
        "label": "BuilderHub create tool",
        "value": "builder_hub"
    },
    {
        "label": "BONES CLI",
        "value": "bones_cli"
    },
    {
        "label": "Custom managed",
        "value": "custom_managed"
    }
]

export const FABRIC = [
    {
        "label": "Corp",
        "id": "corp"
    },
    {
        "label": "Prod",
        "id": "prod"
    }
]

export const RADIO = [
    {
        "label": "Yes",
        "value": "true"
    },
    {
        "label": "No",
        "value": "false"
    }
]

export const VIP_SCHEMA = [
    {
        "label": "Internal VIP",
        "value": "internal"
    },
    {
        "label": "External VIP",
        "value": "external"
    }
]

export const ALL_OPERATING_SYSTEMS = [
    {
        "id":"AL2_5_4_X86_64", 
        "label": "Amazon Linux 2 5.4 Kernel x86_64"
    },
    {   
        "id":"AL2_AARCH64", 
        "label": "Amazon Linux 2 5.4 Kernel arm64"
    },
    {
        "id":"AMAZON_LINUX_2012_4_4_WITH_RHEL5_64_PVVS",
        "label":" Amazon Linux 2012 4.4 Kernel"
    },
    {
        "id":"AMAZON_LINUX_2012_4_9_WITH_RHEL5_64_PVVS", 
        "label": "Amazon Linux 2012 4.9 Kernel"
    },
    {   "id":"AMAZON_LINUX_2012_WITH_RHEL5_64_PVVS",
        "label": "Amazon Linux 2012"
    },
    {   "id":"SEAL_2012_4_9_WITH_RHEL5_64_PVVS",
        "label": "SEAL 2012 4.9 Kernel"
    },
    {   
        "id":"SEAL_2012_WITH_RHEL5_64_PVVS", 
        "label": "SEAL 2012"
    }
]

export const ALL_INSTANCE_TYPES = [
    "c1.medium",
    "c1.xlarge",
    "c3.2xlarge",
    "c3.4xlarge",
    "c3.8xlarge",
    "c3.large",
    "c3.xlarge",
    "c4.2xlarge",
    "c4.4xlarge",
    "c4.8xlarge",
    "c4.large",
    "c4.xlarge",
    "c5.12xlarge",
    "c5.18xlarge",
    "c5.24xlarge",
    "c5.2xlarge",
    "c5.4xlarge",
    "c5.9xlarge",
    "c5.large",
    "c5.metal",
    "c5.xlarge",
    "c5a.12xlarge",
    "c5a.16xlarge",
    "c5a.24xlarge",
    "c5a.2xlarge",
    "c5a.4xlarge",
    "c5a.8xlarge",
    "c5a.large",
    "c5a.xlarge",
    "c5d.18xlarge",
    "c5d.2xlarge",
    "c5d.4xlarge",
    "c5d.9xlarge",
    "c5d.large",
    "c5d.xlarge",
    "c5n.18xlarge",
    "c5n.2xlarge",
    "c5n.4xlarge",
    "c5n.9xlarge",
    "c5n.large",
    "c5n.xlarge",
    "c6g.12xlarge",
    "c6g.16xlarge",
    "c6g.2xlarge",
    "c6g.4xlarge",
    "c6g.8xlarge",
    "c6g.large",
    "c6g.medium",
    "c6g.xlarge",
    "c6gd.12xlarge",
    "c6gd.16xlarge",
    "c6gd.2xlarge",
    "c6gd.4xlarge",
    "c6gd.8xlarge",
    "c6gd.large",
    "c6gd.medium",
    "c6gd.xlarge",
    "d2.2xlarge",
    "d2.4xlarge",
    "d2.8xlarge",
    "d2.xlarge",
    "g2.2xlarge",
    "g4dn.12xlarge",
    "g4dn.16xlarge",
    "g4dn.2xlarge",
    "g4dn.4xlarge",
    "g4dn.8xlarge",
    "g4dn.xlarge",
    "i2.2xlarge",
    "i2.4xlarge",
    "i2.8xlarge",
    "i2.xlarge",
    "i3.16xlarge",
    "i3.2xlarge",
    "i3.4xlarge",
    "i3.8xlarge",
    "i3.large",
    "i3.xlarge",
    "i3en.12xlarge",
    "i3en.24xlarge",
    "i3en.2xlarge",
    "i3en.3xlarge",
    "i3en.6xlarge",
    "i3en.large",
    "i3en.xlarge",
    "m1.large",
    "m1.medium",
    "m1.small",
    "m1.xlarge",
    "m2.2xlarge",
    "m2.4xlarge",
    "m2.xlarge",
    "m3.2xlarge",
    "m3.large",
    "m3.medium",
    "m3.xlarge",
    "m4.10xlarge",
    "m4.16xlarge",
    "m4.2xlarge",
    "m4.4xlarge",
    "m4.large",
    "m4.xlarge",
    "m5.12xlarge",
    "m5.24xlarge",
    "m5.2xlarge",
    "m5.4xlarge",
    "m5.large",
    "m5.xlarge",
    "m5a.12xlarge",
    "m5a.16xlarge",
    "m5a.24xlarge",
    "m5a.2xlarge",
    "m5a.4xlarge",
    "m5a.8xlarge",
    "m5a.large",
    "m5a.xlarge",
    "m5d.12xlarge",
    "m5d.2xlarge",
    "m5d.4xlarge",
    "m5d.large",
    "m5d.xlarge",
    "m6g.12xlarge",
    "m6g.16xlarge",
    "m6g.2xlarge",
    "m6g.4xlarge",
    "m6g.8xlarge",
    "m6g.large",
    "m6g.medium",
    "m6g.xlarge",
    "m6gd.12xlarge",
    "m6gd.16xlarge",
    "m6gd.2xlarge",
    "m6gd.4xlarge",
    "m6gd.8xlarge",
    "m6gd.large",
    "m6gd.medium",
    "m6gd.xlarge",
    "p2.8xlarge",
    "p3.16xlarge",
    "p3.2xlarge",
    "p3.8xlarge",
    "p4d.24xlarge",
    "r3.2xlarge",
    "r3.4xlarge",
    "r3.8xlarge",
    "r3.large",
    "r3.xlarge",
    "r4.16xlarge",
    "r4.2xlarge",
    "r4.4xlarge",
    "r4.8xlarge",
    "r4.large",
    "r4.xlarge",
    "r5.12xlarge",
    "r5.24xlarge",
    "r5.2xlarge",
    "r5.4xlarge",
    "r5.large",
    "r5.xlarge",
    "r5a.12xlarge",
    "r5a.16xlarge",
    "r5a.24xlarge",
    "r5a.2xlarge",
    "r5a.4xlarge",
    "r5a.8xlarge",
    "r5a.large",
    "r5a.xlarge",
    "r5d.12xlarge",
    "r5d.24xlarge",
    "r5d.2xlarge",
    "r5d.4xlarge",
    "r5d.large",
    "r5d.xlarge",
    "r5n.12xlarge",
    "r5n.16xlarge",
    "r5n.24xlarge",
    "r5n.2xlarge",
    "r5n.4xlarge",
    "r5n.8xlarge",
    "r5n.large",
    "r5n.xlarge",
    "r6g.12xlarge",
    "r6g.16xlarge",
    "r6g.2xlarge",
    "r6g.4xlarge",
    "r6g.8xlarge",
    "r6g.large",
    "r6g.medium",
    "r6g.xlarge",
    "r6gd.12xlarge",
    "r6gd.16xlarge",
    "r6gd.2xlarge",
    "r6gd.4xlarge",
    "r6gd.8xlarge",
    "r6gd.large",
    "r6gd.medium",
    "r6gd.xlarge",
]

export const ALL_ASG_GROUPS = {   
    "NA": [
        {"value": "us-east-1a" , "label": "us-east-1a (IAD7)"},
        {"value": "us-east-1b" , "label": "us-east-1b (IAD1)"},
        {"value": "us-east-1c" , "label": "us-east-1c (IAD5)", "disabled":true},
        {"value": "us-east-1d" , "label": "us-east-1d (IAD6)"},
        {"value": "us-east-1e" , "label": "us-east-1e (IAD12)"},
        {"value": "us-east-1f" , "label": "us-east-1f (IAD62)"},
        {"value": "us-west-2a" , "label": "us-west-2a (PDX2)","disabled":true},
        {"value": "us-west-2b" , "label": "us-west-2b (PDX1)","disabled":true},
        {"value": "us-west-2c" , "label": "us-west-2c (PDX4)","disabled":true},
        {"value": "us-west-2d" , "label": "us-west-2d (PDX80)","disabled":true}
    ],
    "EU": [
        {"value": "eu-west-1a" , "label": "eu-west-1a (DUB4)"},
        {"value": "eu-west-1b" , "label": "eu-west-1b (DUB2)"},
        {"value": "eu-west-1c" , "label": "eu-west-1c (DUB8)"},
        {"value": "eu-west-1d" , "label": "eu-west-1d (DUB62)"}
    ],
    "JP": [
        {"value": "ap-northeast-1c" , "label": "ap-northeast-1c (NRT12)"},
        {"value": "ap-northeast-1d" , "label": "ap-northeast-1d (NRT55)"}
    ],
    "IN": [
        {"value": "ap-south-2a" , "label": "ap-south-2a (HYD100-physical/BPM-Prod)"},
        {"value": "ap-south-2b" , "label": "ap-south-2b (HYD110-physical/BPM-Prod)"},
        {"value": "ap-south-2c" , "label": "ap-south-2c (HYD120-physical/BPM-Prod)"},
        {"value": "ap-south-1a" , "label": "ap-south-1a (BOM52-physical/BPM-Prod)","disabled":true},
        {"value": "ap-south-1b" , "label": "ap-south-1b (BOM54-physical/BPM-Prod)","disabled":true},
        {"value": "ap-south-1c" , "label": "ap-south-1c (BOM53-physical/BPM-Prod)","disabled":true}
    ]
}

export const ALL_POD_NAMES = {   
  "NA": [
    "IADCell1"
  ],
  "EU": [
    "DUBCell1",
    "DUBCell2",
    "DUBCell3"
  ],
  "JP": [
     "NRTCell1",
     "NRTCell2",
     "NRTCell3",
  ],
  "IN": [
    "HYDCell1",
    "HYDCell2",
  ],
  "default": [
    "CellDetails"
  ]
}

export const STACK_NODE_TYPE = "stack";
export const RESILIENCE_STACK_SETUP_WORKFLOW = "RESILIENCE_STACK_SETUP_WORKFLOW";
export const BINDLE_URL = "https://bindles.amazon.com/resource";

export const INFORMATION_HEADERS = {
    pipelineData: "Pipeline Information",
    podData: "Pod Information",
    awsData: "AWS Information"
}

export const getAWSCardItems = (cellName, sourceName) => {
    return {
        'key': cellName,
        'cellName': cellName,
        'sourceAccountName': sourceName,
        'destinationAccountName': `${sourceName}-${cellName}`
    }
}

export const getCellNameKeys = (region) => {
    let cellNamesMap = new Map();
    if(region) {
        ALL_POD_NAMES[region].forEach( cellName => {
            cellNamesMap = {
                ...cellNamesMap, [cellName]: ''
            }
        })
    }
    return cellNamesMap;
}

export const SNOW_PERMISSIONS_TO_ACTOR_MAP = {
    "ApolloEnv:SNOWPlatform/Prod" : "aaa",
    139200550426: "aws"
}

export const APOLLO_PERMISSION_ACTIONS = [
    "Edit",
    "CreateChild",
    "Deploy"
]